import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/accessgroups', params),
    getById: (id) => Api.get('/cent/accessgroup/' + id, null),
    save: (entity) => Api.post('/cent/accessgroup', entity),
    update: (id, entity) => Api.put('/cent/accessgroup/' + id, entity),
    delete: (id) => Api.delete('/cent/accessgroup/' + id),
};